import React from 'react';
import { useShieldPRDTelemetryForChromeApp } from 'App/ShieldPRD/useShieldPRDTelemetryForChromeApp';

export const ShieldPRDForChromeApp: React.FC = () => {
	useShieldPRDTelemetryForChromeApp();
	return null;
};
